import server from 'common/utils/server';
import { DEFAULT_SUBSCRIPTION } from 'alchemyScorecard/components/Subscriptions/constants';
import { utcToLocal, localToUtc } from 'trends/company/utils';

export const initialState = {
  loading: false,
  updating: false,
  subscription: {},
};

export function subscriptionsState(state = initialState, action) {
  switch (action.type) {
    case 'subscriptionsSlideout/SET_LOADING': {
      const { loading } = action.data;
      return {
        ...state,
        loading,
      };
    }
    case 'subscriptionsSlideout/SET_SUBSCRIPTION': {
      const { subscription } = action.data;
      return {
        ...state,
        subscription,
        loading: false,
      };
    }
    case 'subscriptionsSlideout/UPDATE_SUBSCRIPTION_ATTR': {
      const { newAttrs } = action.data;
      return {
        ...state,
        subscription: {
          ...state.subscription,
          ...newAttrs,
        },
      };
    }
    case 'subscriptionsSlideout/SET_UPDATING': {
      const { updating } = action.data;
      return {
        ...state,
        updating,
      };
    }
    default: {
      return state;
    }
  }
}

export const getSubscription = subscriptionType => async dispatch => {
  dispatch({
    type: 'subscriptionsSlideout/SET_LOADING',
    data: { loading: true },
  });
  const subscription = await server.get(
    '/api/v1/subscription',
    { subscription_type: subscriptionType },
    { format: 'json' }
  );

  if (subscription) {
    dispatch({
      type: 'subscriptionsSlideout/SET_SUBSCRIPTION',
      data: {
        subscription: {
          id: subscription.id,
          interval: subscription.interval,
          subscriptionType: subscription.subscription_type,
          sendEmailAt: subscription.send_email_at,
        },
      },
    });
  } else {
    dispatch({
      type: 'subscriptionsSlideout/SET_SUBSCRIPTION',
      data: {
        subscription: {
          ...DEFAULT_SUBSCRIPTION,
          subscriptionType,
        },
      },
    });
  }
};

export const createOrUpdateSubscription =
  subscriptionData => async dispatch => {
    dispatch({
      type: 'subscriptionsSlideout/SET_UPDATING',
      data: { updating: true },
    });
    const createOrUpdate = subscriptionData.id ? server.put : server.post;
    const subscription = await createOrUpdate(
      `/api/v1/subscription/${subscriptionData.id || ''}`,
      {
        interval: subscriptionData.interval,
        subscription_type: subscriptionData.subscriptionType,
        send_email_at: subscriptionData.sendEmailAt,
      },
      { format: 'json' }
    );
    dispatch({
      type: 'subscriptionsSlideout/SET_UPDATING',
      data: { updating: false },
    });

    dispatch({
      type: 'subscriptionsSlideout/SET_SUBSCRIPTION',
      data: {
        subscription: {
          id: subscription.id,
          interval: subscription.interval,
          subscriptionType: subscription.subscription_type,
          sendEmailAt: subscription.send_email_at,
        },
      },
    });
  };
